import React from "react";
import * as constants from "../constants";
import { FormControl } from "react-bootstrap";

const FilterParticipants = ({ filters, onChange}) => {
    return (
        <>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_ID}
                    defaultValue={filters?.[constants.FIELD_ID] || ''}
                    onChange={(e) => onChange(constants.FIELD_ID, e.target.value)}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_LASTNAME}
                    defaultValue={filters?.[constants.FIELD_LASTNAME] || ''}
                    onChange={(e) => onChange(constants.FIELD_LASTNAME, e.target.value.toLowerCase())}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_NAME}
                    defaultValue={filters?.[constants.FIELD_NAME] || ''}
                    onChange={(e) => onChange(constants.FIELD_NAME, e.target.value.toLowerCase())}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_PATRONYMIC}
                    defaultValue={filters?.[constants.FIELD_PATRONYMIC] || ''}
                    onChange={(e) => onChange(constants.FIELD_PATRONYMIC, e.target.value.toLowerCase())}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_COMPANY}
                    defaultValue={filters?.[constants.FIELD_COMPANY] || ''}
                    onChange={(e) => onChange(constants.FIELD_COMPANY, e.target.value.toLowerCase())}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_ROLES}
                    defaultValue={filters?.[constants.FIELD_ROLES] || ''}
                    onChange={(e) => onChange(constants.FIELD_ROLES, e.target.value.toLowerCase())}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name={constants.FIELD_TAGS}
                    defaultValue={filters?.[constants.FIELD_TAGS] || ''}
                    onChange={(e) => onChange(constants.FIELD_TAGS, e.target.value.toLowerCase())}
                />
            </th>
        </>
    );
};

export default FilterParticipants;
